<template>
  <v-app
    style="
      background-attachment: fixed;
      background: #e9e9e9;
    "
  >
    <v-app-bar
      color="rgba(255, 255, 255, 0.7)"
      elevate-on-scroll
      fixed
    >
      <div @click="toHome" class="home">
        Open Source Software : Crypto Pay App
      </div>

      <v-spacer/>

      <menus/>
    </v-app-bar>

    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import Menus from '../components/commerce/components/Menus.vue'

export default {
  components: {
    Menus,
  },
  methods: {
    toHome: function(){
      if(this.$route.path !== '/commerce'){
        this.$router.push({path: '/commerce'});
      }      
    }
  }
}
</script>

<style>
.home:hover {
  cursor: pointer;
}
</style>